/** Weergavenaam van een contact uit het adresboek. */
export function formatContactName(parts: {
  first_name: string;
  last_name: string;
  tussenvoegsel?: string | null;
}): string {
  const t = parts.tussenvoegsel?.trim();
  return [parts.first_name, t, parts.last_name].filter(Boolean).join(" ");
}
